$(document).ready(function() {
         
  var imgs = $('.modal-slider .single-img img');//jQuery class selector
    imgs.each(function(){
      var img = $(this);
      var width = img.width(); //jQuery width method
      var height = img.height(); //jQuery height method
      if(width < height){
         img.addClass('portrait');
      }else{
         img.addClass('landscape');
      }
  });

  var imgs = $('.modal-slider .single-img img');//jQuery class selector
    imgs.each(function(){
      var img = $(this);
      var width = img.width(); //jQuery width method
      var height = img.height(); //jQuery height method
      if(width < height){
         img.addClass('portrait');
      }else{
         img.addClass('landscape');
      }
  });
       
                  
  
    $('.modal-slider').slick({
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 2500,
      slidesToShow: 1,
      fade: true,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      dots: false,
//       asNavFor: '.page-slider'
    });
//     $('.page-slider').slick({
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       asNavFor: '.modal-slider',
//       dots: true,
//       centerMode: true,
//       variableWidth: true,
//       focusOnSelect: true
//     });
    
});